import {TranslateKey} from '../../../locale/type';
import {t} from '../../getTranslations';
import {getDateDifference} from './getDateDifference';

// https://podotree.atlassian.net/wiki/spaces/SVC/pages/2630551502#4.-BM---%EA%B8%B0%EB%8B%A4%EB%AC%B4
export function getRemainText(
  endDate: Date,
  now: Date,
  appendExtraText = true
): string {
  const {days, hours, minutes} = getDateDifference({
    dateLeft: endDate,
    dateRight: now,
  });
  if (!days && !hours && !minutes) {
    return appendExtraText
      ? `${t('common_time_left', {
          values: {
            value: t(REMAIN_TEXT_UNDER_A_MIN_KEY),
          },
        })}`
      : t(REMAIN_TEXT_UNDER_A_MIN_KEY);
  }
  // 1일 넘게 남은 경우는 분단위는 보여주지 않습니다.
  const remainDateArr =
    days > 0 ? [days.toLocaleString(), hours, 0] : [days, hours, minutes];
  const timeText = remainDateArr.reduce((acc, item, index) => {
    if (item) {
      return `${acc}${t(DATE_ITEM_SUFFIX_KEY_LIST[index], {values: {value: item}})} `;
    }
    return acc;
  }, '') as string;

  return appendExtraText
    ? `${t('common_time_left', {
        values: {
          value: timeText.trimEnd(),
        },
      })}`
    : String(timeText).trimEnd();
}

const DATE_ITEM_SUFFIX_KEY_LIST: TranslateKey[] = [
  'common_period_day',
  'common_period_hour',
  'common_period_minute',
];
export const REMAIN_TEXT_UNDER_A_MIN_KEY =
  'contenthome_single_rent_less_minute';
